enum TipoOperacao {
    Entrada = 0,
    Saida = 1
}

export default TipoOperacao;